module.exports = __webpack_public_path__ + "img/subscription_confirmed.4261f78a.png";